import React from "react";
import { Lock, Sparkles } from "lucide-react";
import { Button } from "./ui/button";

export default function PremiumGate({ premium, onUpgrade, title = "Premium insight", children }) {
  if (premium) return children;
  return (
    <div data-testid="premium-gate" className="relative rounded-2xl overflow-hidden">
      <div className="pointer-events-none select-none blur-[7px] opacity-60 max-h-[520px] overflow-hidden">
        {children}
      </div>
      <div className="absolute inset-0 grid place-items-center bg-slate-950/55">
        <div className="text-center px-6">
          <div className="h-12 w-12 rounded-2xl bg-gradient-to-br from-orange-400 to-rose-500 grid place-items-center mx-auto">
            <Lock className="h-6 w-6 text-white" />
          </div>
          <h4 className="font-display text-lg font-bold mt-3">{title} is premium</h4>
          <p className="text-sm text-slate-300 mt-1 max-w-xs mx-auto">Upgrade to unlock the full analysis, competitor matrix, pricing research, 90-day plan, brand kit and the AI model arena.</p>
          <Button data-testid="gate-upgrade-button" onClick={onUpgrade} className="cta-btn mt-4">
            <Sparkles className="h-4 w-4 mr-1" /> Unlock premium
          </Button>
        </div>
      </div>
    </div>
  );
}
